import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    Label,
    Input,
    FormGroup,
    Form,
    Col,
    UncontrolledPopover,
    PopoverBody
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import uuid from 'uuid';
import {Utils} from '../../../utils/utils';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import FormWrapper from './../../commonComponents/formWrapper/FormWrapper.container';
import AdditionalTitle from './../additionalTitle/AdditionalTitle.container';
import './InsertAccreditation.css';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import Select from '../../commonComponents/customSelect/CustomSelect.container';
import { CryptoUtils } from '../../../utils/cryptoUtils';

const requiredSelectFields = ['level','personCountry'];

class InsertAccreditation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            titleOrig: '',
            titleEn: '',
            titlesAdditional: [],
            dateIssued: moment(),
            level: '',
            personFirstName: '',
            personLastName: '',
            email: '',
            personContinent: this.props.continentCode,
            personCountry: '',
            nationalId: '',
            requiredFieldError: null,
            successMessage: '',
            orgContinent: null,
            orgCountry: null,
            orgId: null,
        };
    };

    componentDidMount() {
        this.onMount();
        if (this.props.isBava) {
            this.props.onGetManagedOrgs();
        }
    };

    componentWillUnmount() {
        this.props.onContinentSet('');
        this.props.onUnmount();
    }

    onMount = () => {
        this.props.onGetLevels();
        this.props.onGetAccreditationGroups();
        this.props.onGetAdditionalLangs();
        this.props.onGetOrganization();
    };

    componentWillReceiveProps(nextProps) {
        if (this.state.personContinent !== nextProps.continentCode) {
            this.setState({personContinent: nextProps.continentCode})
        }
        if (nextProps.success && this.props.success !== nextProps.success) {
            this.cleanPersonData();
        }
    };

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.state.orgCountry !== nextState.orgCountry) {
            this.props.onGetManagedOrgs(nextState.orgCountry);
        }
        if (!_.isEqual(this.props.managedOrgs, nextProps.managedOrgs) && !_.isEmpty(nextProps.managedOrgs) &&
            this.state.orgId && !_.some(nextProps.managedOrgs, option => option.value === this.state.orgId)) {
            this.setState({orgId: null});
        }
    }

    render() {
        if (this.props.signingKeyLoading || this.props.orgLoading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
        }

        if (this.props.isSigningRequired && _.isNil(this.props.signingKey)) {
            return (
                <div>
                    <h4 className='page-label'>{_.get(this.props.translation, 'insert_accreditation.label')}</h4>
                    <div className="carrot-red">
                        {_.get(this.props.translation, "insert_accreditation.no_certificate_message_start")}
                        <a href="/security">
                            {_.get(this.props.translation, "insert_accreditation.no_certificate_message_link")}
                        </a>
                        {_.get(this.props.translation, "insert_accreditation.no_certificate_message_end")}
                    </div>
                </div>
            );
        }

        return (
            <div className="insert-accreditation-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'insert_accreditation.success_message')}>
                    <div className="insert-accreditation-form">
                        <h4 className='page-label'>{_.get(this.props.translation, 'insert_accreditation.label')}</h4>
                        <Form onSubmit={this.onSubmit}>
                            <FormGroup row>
                                <Col sm={12}>
                                    {this.renderDepartmentFormGroup()}
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={7}>
                                    {this.renderOrganizationFormGroup()}
                                    <h5>{_.get(this.props.translation, 'accreditation.accreditation_label')}</h5>
                                    {this.renderTitlesFormGroups()}
                                    {this.renderAccreditationFormGroups()}
                                    {this.renderAdditionalTitlesFormGroups()}
                                </Col>
                                <Col sm={5}>
                                    <h5>{_.get(this.props.translation, 'accreditation.person_label')}</h5>
                                    {this.renderPersonFormGroups()}
                                </Col>
                            </FormGroup>

                            <div className="buttons-group">
                                <Button type="submit"
                                        className="olive-green-btn">{_.get(this.props.translation, 'insert_accreditation.submit_button')}</Button>
                            </div>
                        </Form>
                    </div>
                </FormWrapper>
            </div>
        );
    };

    renderOrganizationFormGroup = () => {
        if (!this.props.isBava) {
            return null;
        }

        let paramsList = [
            {
                value: 'orgContinent',
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
                type: 'select',
                content: [
                    {value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label)},
                    ...Utils.getLocationOptions(
                        this.props.continents,
                        _.get(this.props.translation, sharedLabelsPath.continents)
                    )
                ],
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                isDisabled: !this.props.continents,
                onChange: this.handleOrgContinentChange,
                popoverParams: {
                    noPopover: true
                },
            },
            {
                value: "orgCountry",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                type: 'select',
                content: [
                    {value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label)},
                    ...Utils.getLocationOptions(
                        this.props.locationData[this.state.orgContinent],
                        _.get(this.props.translation, sharedLabelsPath.countries)
                    )
                ],
                placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isDisabled: !this.props.continents,
                popoverParams: {
                    noPopover: true
                },
            },
            {
                value: "orgId",
                type: "select",
                title: _.get(this.props.translation, sharedLabelsPath.org_label) + '*',
                content: this.props.managedOrgs,
                placeholder: _.get(this.props.translation, _.get(this.props.translation, sharedLabelsPath.org_label)),
                isDisabled: this.props.loadingManagedOrgs,
                isRequired: true,
                popoverParams: {
                    noPopover: true
                },
                onChange: this.handleOrgIdChange
            }
        ];

        return [
            <h5 key='label'>{_.get(this.props.translation, sharedLabelsPath.org_label)}</h5>,
            ..._.map(paramsList, this.getFormGroup)
        ]
    };

    handleOrgContinentChange = (selectedOption) => {
        this.setState({
            orgContinent: selectedOption.value,
            orgCountry: null,
            orgId: null
        })
    };

    handleOrgIdChange = (selectedOption) => {
        this.setState({orgId: selectedOption.value});
        this.props.onContinentSetByCountry(selectedOption.countryCode);
        this.setState({personCountry: selectedOption.countryCode});
    };

    renderDepartmentFormGroup = () => {
        if (this.props.accreditationGroupName) {
            return (
                <FormGroup row className="insert-accreditation-department-form-group">
                    <div className="insert-accreditation-department-container">
                        <h6>{_.get(this.props.translation, sharedLabelsPath.accreditation_group_label)}:</h6>
                        <div>{this.props.accreditationGroupName}</div>
                    </div>
                </FormGroup>
            )
        }
    };

    renderTitlesFormGroups = () => {
        let paramsList = [
            {
                value: "titleOrig",
                title: _.get(this.props.translation, 'accreditation.accreditation_title_orig_label') + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, 'accreditation.accreditation_title_orig_input_placeholder')
            },
            {
                value: "titleEn",
                title: _.get(this.props.translation, 'accreditation.accreditation_title_en_label') + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, 'accreditation.accreditation_title_en_input_placeholder')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    renderAdditionalTitlesFormGroups = () => {
        let title = (
            <h6 className="additional-langs-title" key="additional-langs-title">
                <span> {_.get(this.props.translation, 'accreditation.additional_translations_label')}</span>
                <IconContainer
                    className="add-additional-lang-icon olive-green"
                    icon="add"
                    onClick={this.addAdditionalTitle}
                    title={_.get(this.props.translation, 'accreditation.add_additional_translations_label')}
                />
            </h6>
        );
        let result = [title];

        this.state.titlesAdditional.forEach((elem) => {
            result.push(
                <AdditionalTitle
                    key={elem.id}
                    id={elem.id}
                    lang={elem.lang}
                    title={elem.title}
                    langs={this.getAvailableLang(elem.id)}
                    onChangeLang={this.handleChangeAdditionalTitleLang}
                    onChangeTitle={this.handleChangeAdditionalTitle}
                    onRemove={this.removeAdditionalTitle}
                    required
                    requiredFieldError={this.state.requiredFieldError === elem.id}
                />
            );
        });

        return result;
    };

    renderAccreditationFormGroups = () => {
        let params = {
            value: "level",
            title: _.get(this.props.translation, 'accreditation.level_label') + "*",
            isDisabled: _.isNil(this.props.levels),
            content: Utils.getLevelsOptions(
                this.props.levels,
                _.get(this.props.translation, 'levels')
            ),
            placeholder: _.get(this.props.translation, 'accreditation.level_input_placeholder'),
            isRequired: true
        };

        return [this.renderDateIssued(), this.getSelectFormGroup(params)];
    };

    renderDateIssued = () => {
        return (
            <FormGroup row key='date-issued'>
                <Label for='date-issued'
                       sm={3}>{_.get(this.props.translation, 'accreditation.date_issued_label')}*</Label>
                <Col sm={9}>
                    <DatePicker
                        customInput={<Input
                            id='date-issued'
                        />}
                        selected={this.state.dateIssued}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        required
                        onChange={this.handleChangeDate}
                        maxDate={moment()}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderPersonFormGroups = () => {
        let paramsList = [
            {
                value: "personFirstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.first_name_label)
            },
            {
                value: "personLastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            },
            {
                value: "email",
                title: _.get(this.props.translation, sharedLabelsPath.email_label) + (Utils.isDateHistorical(this.state.dateIssued) ? "" : "*"),
                type: "email",
                isRequired: !Utils.isDateHistorical(this.state.dateIssued),
                placeholder: _.get(this.props.translation, sharedLabelsPath.email_label)
            },
            {
                value: "nationalId",
                title: _.get(this.props.translation, sharedLabelsPath.national_id_label) + "*",
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.national_id_label),
                popoverHintParams: {
                    hintText: _.get(this.props.translation, 'accreditation_requests.national_id_hint')
                },
                formGroupHintText: _.get(this.props.translation, 'accreditation_requests.national_id_expose_hint')
            },
            {
                value: "personContinent",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label) + "*",
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                onChange: this.handleChangeContinent,
                isRequired: true,
                isDisabled: !this.props.continents
            },
            {
                value: "personCountry",
                title: _.get(this.props.translation, sharedLabelsPath.country_label) + "*",
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isRequired: true,
                isDisabled: !this.props.countries
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    getFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        if (params.type === 'select') {
            return this.getSelectFormGroup(params)
        }

        let id = _.kebabCase(params.value);
        return [
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>
                    {params.title}
                    {this.renderHintPopover(params.value, params.popoverHintParams)}
                </Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={this.state[params.value]}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}
                    >
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>,
            params.formGroupHintText ?
                <div className="form-group-hint" key={params.title + "form-group-hint"}>{params.formGroupHintText}</div>
                : null
        ];
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>
                    {params.title}
                    {this.renderHintPopover(params.value, params.popoverHintParams)}
                </Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange || this.handleChangeSelect(params.value)}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderHintPopover = (fieldName, params) => {
        if (!_.isNil(params)) {
            return (
                <div className="insert-accreditation-hint-container">
                    <span id={fieldName + '-hint'} className='insert-accreditation-hint-icon-container'>
                        <IconContainer 
                            icon='question_mark'
                            title={_.get(this.props.translation, sharedLabelsPath.about_label)}
                        />
                    </span>
                    <UncontrolledPopover trigger="legacy" placement="top" target={fieldName + '-hint'}>
                        <PopoverBody>
                            <div>
                                {Utils.getTagsFromStringWithStyles(params.hintText)}
                            </div>
                        </PopoverBody>
                    </UncontrolledPopover >
                </div>
            );
        }
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        let titles = {
            original: this.state.titleOrig,
            en: this.state.titleEn
        };

        this.state.titlesAdditional.forEach(elem => {
            if (elem.lang !== "") titles[elem.lang] = elem.title;
        });

        let data = {
            accreditationGroupId: this.props.accreditationGroupId,
            accreditationData: {
                titles: titles,
                issuedAt: this.state.dateIssued.format("YYYY-MM-DD"),
                level: this.state.level
            },
            verifiedIdentity: {
                firstName: this.state.personFirstName,
                lastName: this.state.personLastName,
                countryCode: this.state.personCountry,
                nationalId: this.state.nationalId
            }
        };

        if (this.state.email) {
            data["email"] = this.state.email;
        }

        if (this.state.orgId) {
            data.managedOrgId = this.state.orgId;
        }

        if (this.props.isSigningRequired) {
            this.props.onSetSubmitFormLoading();
            CryptoUtils.signAccreditation(this.props.signingKey, data).then((signingData) => {
                this.props.onInsert(signingData);
            })
        } else {
            this.props.onInsert(data);
        }
    };

    cleanPersonData = () => {
        this.setState({
            personFirstName: '',
            personLastName: '',
            email: '',
            nationalId: ''
        });
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleChangeDate = (date) => {
        this.setState({dateIssued: date});
    };

    handleChangeSelect = (fieldKey) => (selectedOption) => {
        this.setState({[fieldKey]: selectedOption.value});
    };

    handleChangeContinent = (selectedOption) => {
        this.setState({personCountry: ''});
        this.props.onContinentSet(selectedOption.value);
    };

    handleChangeAdditionalTitle = (id) => (e) => {
        let newTitles = this.state.titlesAdditional.map((elem) => {
            if (elem.id === id) elem.title = e.target.value;
            return elem;
        });

        this.setState({titlesAdditional: newTitles});
    };

    handleChangeAdditionalTitleLang = (id, value) => {
        let newTitles = this.state.titlesAdditional.map((elem) => {
            if (elem.id === id) elem.lang = value;
            return elem;
        });

        this.setState({titlesAdditional: newTitles});
    };

    addAdditionalTitle = () => {
        let newTitle = {
            id: uuid(),
            lang: '',
            title: ''
        };

        this.setState({titlesAdditional: [...this.state.titlesAdditional, newTitle]});
    };

    removeAdditionalTitle = (id) => () => {
        let newTitles = this.state.titlesAdditional.filter((elem) => elem.id !== id);

        this.setState({titlesAdditional: newTitles});
    };

    getAvailableLang(id) {
        let disabledLangs = this.state.titlesAdditional.filter(elem => elem.id !== id).map(elem => elem.lang);

        return _.values(this.props.additionalLangs).filter(lang => !disabledLangs.includes(lang));
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        _.map(this.state.titlesAdditional, title => {
            if (title.lang === '' && !error) {
                error = title.id;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }

    // handleAccreditationGroupChange = (e) => {
    //     this.setState({accreditationGroupId: e.target.value});
        // if (!_.isEmpty(e.target.value)) {
        //     this.props.onGetLevels(e.target.value)
        // }
    // }
}

InsertAccreditation.propTypes = {
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    accreditationGroupId: PropTypes.string,
    accreditationGroupName: PropTypes.string,
    additionalLangs: PropTypes.array,
    levels: PropTypes.array,
    success: PropTypes.bool,
    signingKey: PropTypes.object,
    signingKeyLoading: PropTypes.bool,
    isSigningRequired: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    isBava: PropTypes.bool,
    loadingManagedOrgs: PropTypes.bool,
    managedOrgs: PropTypes.array,
    locationData: PropTypes.object,
    onInsert: PropTypes.func.isRequired,
    onSetSubmitFormLoading: PropTypes.func.isRequired,
    onContinentSet: PropTypes.func.isRequired,
    onGetAccreditationGroups: PropTypes.func.isRequired,
    onGetAdditionalLangs: PropTypes.func.isRequired,
    onGetLevels: PropTypes.func.isRequired,
    onGetManagedOrgs: PropTypes.func.isRequired,
    onContinentSetByCountry: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired,
};

export default InsertAccreditation;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/insertAccreditation/InsertAccreditation.js